var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('ErrorSvg',{staticClass:"error-svg"}),_c('h3',[_vm._v("\n    "+_vm._s(_vm.$t('accept-invite.invite-invalid'))+"\n  ")]),_vm._v("\n\n  "+_vm._s(_vm.$t('accept-invite.invite-invalid-msg'))+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }